import useMediaQueries from 'app/hooks/useMediaQueries';
import { useDeleteQuestionnaireMutation } from 'app/services/questionnaires';
import { IProject, ProjectsTableResponse } from 'app/services/responseTypes';
import { DeleteIcon, DeleteDarkIcon } from 'assets/icons';
import { PaginationContext } from 'Components/Pagination/usePagination';
import { useConfirmDeleteModal } from 'Components/Popups/ConfirmDeletePopup';
import Tooltip from 'Components/Tooltips';
import { useContext } from 'react';

interface IDeleteModal {
  project: IProject;
  onDelete?: () => void;
}

const style = {
  desktop:
    'border border-red-200 rounded-lg hover:shadow-lg w-10 h-8 flex items-center justify-center',
  mobile:
    'text-sm px-4 w-full font-semibold bg-white text-black flex justify-start items-center h-10',
};

const DeleteModal = ({ project, onDelete = () => {} }: IDeleteModal) => {
  const { md_down: isMobile } = useMediaQueries();
  const confirmDelete = useConfirmDeleteModal();
  const [deleteQuestionnaire] = useDeleteQuestionnaireMutation();

  const isDeleteActive = project.status === 'draft';
  const onClick = () => {
    if (isDeleteActive)
      confirmDelete('Questionnaire', () =>
        deleteQuestionnaire(project.id.toString()).unwrap().then(onDelete),
      );
  };

  return (
    <div onClick={onClick}>
      <Tooltip message="Delete">
        <div
          className={`${isMobile ? style.mobile : style.desktop} ${
            isDeleteActive ? '' : 'opacity-50'
          }`}
        >
          {isMobile ? (
            <>
              <div className="w-6 mr-2 flex justify-center">
                <DeleteDarkIcon className="text-red-dark" />
              </div>
              <span>Delete</span>
            </>
          ) : (
            <DeleteIcon className="action-icon" />
          )}
        </div>
      </Tooltip>
    </div>
  );
};

export default DeleteModal;
